import { useMemo } from 'react';
import { useGetResources } from '../../../shared/m-anage';

const getAccessPolicyList = (data) => {
  const accessPolicyList = data.find((el) => el.resourcename === 'access_policies');

  if (!accessPolicyList) throw new Error('No access policy found in API response');

  try {
    return JSON.parse(accessPolicyList.resourcevalue);
  } catch {
    throw new Error('Cannot parse resource value from the access policies');
  }
};

export const useAccessMatrix = () => {
  // resources API call returns many resources. We need only access policies
  const response = useGetResources();
  const { data } = response;

  return useMemo(() => {
    if (data) {
      try {
        const accessPolicyList = getAccessPolicyList(data);
        return {
          ...response,
          data: accessPolicyList
        };
      } catch (err) {
      // possible errors:
      // - no access policies
      // - access policies are not JSON parsable
        return {
          ...response,
          error: err
        };
      }
    }
    return response;
  }, [data]);
};
